import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect, } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { Store } from '@ngrx/store';
import { IAppState } from '../app.state';
import {
    CreateFormulario, CreateFormularioAsignados, CreateFormularioAsignadosSuccess, CreateFormularioCentro, CreateFormularioCentroSuccess,
    CreateFormularioGrupo, CreateFormularioGrupoSuccess, CreateFormularioPrograma, CreateFormularioprogramaSuccess, CreateFormularioSuccess,
    DeleteFormulario, DeleteFormularioSuccess,GetFormularioResponses,GetFormularioResponsesSuccess,GetFormularios, GetFormulariosAsignados, GetFormulariosAsignadosSuccess, GetFormulariosSuccess,
    UpdateFormulario, UpdateFormularioSuccess
} from '../actions/formularios.actions';

@Injectable()
export class FormulariosEffects {
    getFormularios$ = createEffect(() =>
        this.actions$.pipe(
            ofType(GetFormularios),
            switchMap(() =>
                this.apiService.getFormularios().pipe(
                    map((formularios: any[]) => GetFormulariosSuccess({ formularios }))
                )
            )
        )
    );

    createFormulario$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CreateFormulario),
            switchMap(payload =>
                this.apiService.createFormulario(payload.formularios).pipe(
                    map((formularios: any) => CreateFormularioSuccess({ formularios }))
                )
            )
        )
    );

    deleteFormulario$ = createEffect(() =>
        this.actions$.pipe(
            ofType(DeleteFormulario),
            switchMap(payload =>
                this.apiService.deleteFormulario(payload.id).pipe(
                    map((formularios: any) => DeleteFormularioSuccess({ formularios }))
                )
            )
        )
    );

    updateFormulario$ = createEffect(() =>
        this.actions$.pipe(
            ofType(UpdateFormulario),
            switchMap(payload =>
                this.apiService.updateFormulario(payload.id, payload.formularios).pipe(
                    map((formularios: any) => UpdateFormularioSuccess({ formularios }))
                )
            )
        )
    );

    getFormulariosAsignados$ = createEffect(() =>
        this.actions$.pipe(
            ofType(GetFormulariosAsignados),
            switchMap(payload =>
                this.apiService.getFormulariosAsignados(payload.id).pipe(
                    map((formulariosAsignados: any[]) => GetFormulariosAsignadosSuccess({ formulariosAsignados }))
                )
            )
        )
    );

    createFormularioAsignados$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CreateFormularioAsignados),
            switchMap(payload =>
                this.apiService.createFormularioAsignado(payload.formulariosAsignados).pipe(
                    map((formulariosAsignados: any) => CreateFormularioAsignadosSuccess({ formulariosAsignados }))
                )
            )
        )
    );

    createFormularioGrupo$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CreateFormularioGrupo),
            switchMap(payload =>
                this.apiService.createFormularioGrupo(payload.formulariosAsignados).pipe(
                    map((formulariosAsignados: any) => CreateFormularioGrupoSuccess({ formulariosAsignados }))
                )
            )
        )
    );

    createFormularioCentro$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CreateFormularioCentro),
            switchMap(payload =>
                this.apiService.createFormularioCentro(payload.formulariosAsignados).pipe(
                    map((formulariosAsignados: any) => CreateFormularioCentroSuccess({ formulariosAsignados }))
                )
            )
        )
    );

    createFormularioPrograma$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CreateFormularioPrograma),
            switchMap(payload =>
                this.apiService.createFormularioCentro(payload.formulariosAsignados).pipe(
                    map((formulariosAsignados: any) => CreateFormularioprogramaSuccess({ formulariosAsignados }))
                )
            )
        )
    );

    getFormularioResponses$ = createEffect(() =>
        this.actions$.pipe(
            ofType(GetFormularioResponses),
            switchMap(payload =>
                this.apiService.getFormularioResponses(payload.id).pipe(
                    map((formularioResponses: any[]) => GetFormularioResponsesSuccess({ formularioResponses }))
                )
            )
        )
    );

    constructor(
        private apiService: ApiService,
        private actions$: Actions,
        private store: Store<IAppState>
    ) { }
}
